module.exports = {
  GuideTagDisplay: {
    PluginName: "Mostrar Etiqueta de Formación",
    Tag: "Etiqueta",
    tagRef: "Referencia de etiqueta",
  },
};
